// Plain SVG icons for navigation – no MUI dependency.
// Paths follow Lucide-style geometry (MIT) for a crisp, consistent set.

const size = 22;

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function SvgIcon({ children, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden
      {...rest}
    >
      {children}
    </svg>
  );
}

export function DashboardIcon() {
  return (
    <SvgIcon>
      <rect x="3" y="3" width="7" height="7" rx="1.5" {...stroke} />
      <rect x="14" y="3" width="7" height="7" rx="1.5" {...stroke} />
      <rect x="14" y="14" width="7" height="7" rx="1.5" {...stroke} />
      <rect x="3" y="14" width="7" height="7" rx="1.5" {...stroke} />
    </SvgIcon>
  );
}

export function CalendarIcon() {
  return (
    <SvgIcon>
      <path d="M8 2v4" {...stroke} />
      <path d="M16 2v4" {...stroke} />
      <rect x="3" y="4" width="18" height="18" rx="2" {...stroke} />
      <path d="M3 10h18" {...stroke} />
    </SvgIcon>
  );
}

export function ArchiveIcon() {
  return (
    <SvgIcon>
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" {...stroke} />
      <path d="M3 3v5h5" {...stroke} />
      <path d="M12 7v5l4 2" {...stroke} />
    </SvgIcon>
  );
}

export function PeopleIcon() {
  return (
    <SvgIcon>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" {...stroke} />
      <circle cx="9" cy="7" r="4" {...stroke} />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" {...stroke} />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" {...stroke} />
    </SvgIcon>
  );
}

/** SMS / two-way customer messages */
export function MessagesIcon() {
  return (
    <SvgIcon>
      <path
        d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        {...stroke}
      />
    </SvgIcon>
  );
}

/** Employee management – single user + add / invite */
export function ManageAccountsIcon() {
  return (
    <SvgIcon>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" {...stroke} />
      <circle cx="9" cy="7" r="4" {...stroke} />
      <line x1="19" x2="19" y1="8" y2="14" {...stroke} />
      <line x1="22" x2="16" y1="11" y2="11" {...stroke} />
    </SvgIcon>
  );
}

export function SettingsIcon() {
  return (
    <SvgIcon>
      <line x1="21" x2="14" y1="4" y2="4" {...stroke} />
      <line x1="10" x2="3" y1="4" y2="4" {...stroke} />
      <line x1="21" x2="12" y1="12" y2="12" {...stroke} />
      <line x1="8" x2="3" y1="12" y2="12" {...stroke} />
      <line x1="21" x2="16" y1="20" y2="20" {...stroke} />
      <line x1="12" x2="3" y1="20" y2="20" {...stroke} />
      <line x1="14" x2="14" y1="2" y2="6" {...stroke} />
      <line x1="8" x2="8" y1="10" y2="14" {...stroke} />
      <line x1="16" x2="16" y1="18" y2="22" {...stroke} />
    </SvgIcon>
  );
}

export function SupportIcon() {
  return (
    <SvgIcon>
      <circle cx="12" cy="12" r="10" {...stroke} />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" {...stroke} />
      <path d="M12 17h.01" {...stroke} />
    </SvgIcon>
  );
}

export function LogoutIcon() {
  return (
    <SvgIcon>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" {...stroke} />
      <polyline points="16 17 21 12 16 7" {...stroke} />
      <path d="M21 12H9" {...stroke} />
    </SvgIcon>
  );
}

/** Developer / internal tools */
export function DevToolsIcon() {
  return (
    <SvgIcon>
      <polyline points="16 18 22 12 16 6" {...stroke} />
      <polyline points="8 6 2 12 8 18" {...stroke} />
    </SvgIcon>
  );
}

/** Appointments list */
export function AppointmentsListIcon() {
  return (
    <SvgIcon>
      <path d="M8 6h13" {...stroke} />
      <path d="M8 12h13" {...stroke} />
      <path d="M8 18h13" {...stroke} />
      <path d="M4 6h.01" {...stroke} />
      <path d="M4 12h.01" {...stroke} />
      <path d="M4 18h.01" {...stroke} />
    </SvgIcon>
  );
}

export function MoreHorizontalIcon() {
  return (
    <SvgIcon>
      <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="19" cy="12" r="1" fill="currentColor" stroke="none" />
      <circle cx="5" cy="12" r="1" fill="currentColor" stroke="none" />
    </SvgIcon>
  );
}
